var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 3.33333C1.3335 2.22876 2.22893 1.33333 3.3335 1.33333H5.51966C6.09356 1.33333 6.60308 1.70057 6.78457 2.24503L7.78311 5.24065C7.99294 5.87013 7.70797 6.55812 7.11448 6.85486L6.21012 7.30704C6.8012 8.33946 7.6607 9.19896 8.69312 9.79004L9.1453 8.88567C9.44204 8.29219 10.13 8.00722 10.7595 8.21705L13.7551 9.21559C14.2996 9.39708 14.6668 9.90659 14.6668 10.4805V12.6667C14.6668 13.7712 13.7714 14.6667 12.6668 14.6667H12.0002C6.10913 14.6667 1.3335 9.89103 1.3335 3.99999V3.33333ZM3.3335 2.66666C2.96531 2.66666 2.66683 2.96514 2.66683 3.33333V3.99999C2.66683 9.15465 6.84551 13.3333 12.0002 13.3333H12.6668C13.035 13.3333 13.3335 13.0349 13.3335 12.6667V10.4805L10.3379 9.48196L9.58545 10.9868C9.42544 11.3068 9.04133 11.4435 8.71515 11.2964C6.93712 10.4948 5.50541 9.06304 4.70375 7.28501C4.55669 6.95883 4.69333 6.57472 5.01336 6.41471L6.5182 5.66229L5.51966 2.66666H3.3335Z",
    fill: "#68666C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.176e84cfb2c4d81616fd0831c0bfe58c.svg";
export { ForwardRef as ReactComponent };